export function assert(condition: unknown, msg: string): asserts condition {
  if (process.env['NODE_ENV'] === 'development' && !condition) {
    throw new Error(msg);
  }
}
